import type { ApiISODateString } from '#/api/types/ApiTypedDate';
import type { I18nFn } from '#/i18n/types/I18nFn';
import type { SearchFacetData } from '#/modules/search/types/SearchFacetData';

export function actionDateFacet(i18n: I18nFn) {
  return {
    id: 'actionDateFacet',
    name: 'actionDate',
    names: ['endsGT', 'startsLT'],
    get title() {
      return i18n('Date');
    },
    type: 'date',
    // Do not apply to date filters
    options: [],
    optionTitles: {},
  } as const satisfies SearchFacetData;
}

export type ActionDateFacetValue = {
  endsGT: ApiISODateString | undefined;
  startsLT: ApiISODateString | undefined;
};
